export default __webpack_public_path__ + "static/media/outside.491b004b.png";